import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaExportarBancosResumen', NominasNominaExportarBancosResumen)

function NominasNominaExportarBancosResumen(NominasNominaBancosResumen) {
  this.get = _get

  function _get(idEmpresa, idNomina, logotipo) {
    return NominasNominaBancosResumen.get(idEmpresa, idNomina).then(function (resumen) {
      let data = resumen.map(function (item) {
        return [item.label, item.data.Total_Pagar]
      })

      return [{
        name: 'Resumen Bancario',
        details: [],
        columns: [
          {label: 'Banco', format: {align: 'right', width: 20}},
          {label: 'Importe', format: {type: 'currency', align: 'right', width: 15}},
        ],
        options: {
          logo: {
            filename: logotipo,
            title: 'FAN Consultores',
            cell: 'A1',
          },
          show_grid: false,
          fixed_column: 'A8',
        },
        data: data,
      }]
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Exportar/Bancos/Resumen.js